import React from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import Shimmer from '@techsoftware/happay-widgets/Shimmer';

export default function ContainerShimmer({ count }) {
  const returnMapped = () => {
    let arr = [];
    for (let i = 0; i < count; i++) {
      arr.push(
        <Grid
          item
          xs={24}
          sm={24}
          md={12}
          xl={12}
          lg={12}
          className={`padding-b-24 padding-lr-30 ${
            i % 2 === 0 ? 'border-right' : ''
          }`}
        >
          <Shimmer shimmerStyle={{ width: '90%' }} height="20" />
          <Shimmer shimmerStyle={{ width: '60%' }} height="30" />
        </Grid>,
      );
    }
    return arr;
  };

  return (
    <Grid
      container
      className={`border-container-imp white-bg border-radius-4 margin-b-24`}
    >
      <Grid item className="payment-card-title border-b">
        <div className={`d-flex padding-lr-30 padding-tb-20`}>
          <Shimmer shimmerStyle={{ width: '40%' }} height="30" />
        </div>
      </Grid>
      <Grid item>
        <Grid container className="padding-30">
          {returnMapped()}
        </Grid>
      </Grid>
    </Grid>
  );
}
